// extracted by mini-css-extract-plugin
module.exports = {"lectorSearch":"lector-single-main_lectorSearch__As2tw","titleFirst":"lector-single-main_titleFirst__FvKbP"};